import styles from './styles.module.css';

const Loader = () => {
  return (
    <div className={ styles.spinner }>Loading...</div>
  )
}

export default Loader;